import { render, staticRenderFns } from "./SubjectAnalysis.vue?vue&type=template&id=5464784c&scoped=true"
import script from "./SubjectAnalysis.vue?vue&type=script&lang=js"
export * from "./SubjectAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464784c",
  null
  
)

export default component.exports